import React from "react";
import type { LegalDoc } from "@/content/legal";

/** Shared renderer for the published legal documents (Privacy Policy, Terms & Conditions). */
export const LegalPage: React.FC<{ doc: LegalDoc; testid?: string }> = ({ doc, testid }) => (
  <div className="bg-white">
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6" data-testid={testid}>
      <h1 className="font-display text-3xl font-semibold tracking-tight text-slate-900">{doc.title}</h1>
      <p className="mt-2 text-sm text-slate-500">
        Effective {doc.effective} · Last updated {doc.updated}
      </p>

      <div className="mt-10 space-y-10">
        {doc.sections.map((section, i) => (
          <section key={section.heading} aria-labelledby={`legal-s${i + 1}`}>
            <h2 id={`legal-s${i + 1}`} className="font-display text-lg font-semibold text-slate-900">
              {i + 1}. {section.heading}
            </h2>
            {section.lines.map((line, j) =>
              line.t === "li" ? (
                <p key={j} className="mt-1.5 flex gap-2 text-sm leading-6 text-slate-600">
                  <span aria-hidden="true" className="mt-2 h-1 w-1 shrink-0 rounded-full bg-slate-400" />
                  <span>{line.s}</span>
                </p>
              ) : (
                <p
                  key={j}
                  className={
                    line.t === "intro"
                      ? "mt-4 text-sm font-medium leading-6 text-slate-700"
                      : "mt-3 text-sm leading-6 text-slate-600"
                  }
                >
                  {line.s}
                </p>
              ),
            )}
          </section>
        ))}
      </div>
    </div>
  </div>
);

export default LegalPage;
